// @flow

import type {ChartType, ModalProps, RiskRating, TabName, GraphDate,
  CompaniesSortOption, CompaniesSortBy, EventsSortBy, SortDir, ExportsSortBy} from '@/types'
import {companiesSortOptions, riskType} from '@/defaults'

export const setActiveTab = (tabName: TabName) => ({
  type: 'SET_ACTIVE_TAB',
  tabName,
})

export const showInfoModal = (component: any, props: ModalProps) => ({
  type: 'SHOW_MODAL',
  modalType: 'info',
  component,
  props,
})

export const showConfirmModal = (props: ModalProps) => ({
  type: 'SHOW_MODAL',
  modalType: 'confirm',
  props,
})

export const showEditModal = (props: ModalProps) => ({
  type: 'SHOW_MODAL',
  modalType: 'edit',
  props,
})

export const closeModal = (modalType: ?string) => ({
  type: 'CLOSE_MODAL',
  modalType,
})

export const setPortfolioCountryFilter = (code: string) => ({
  type: 'SET_PORTFOLIO_COUNTRY_FILTER',
  code,
})

export const setPortfolioSearchFilter = (searchTerm: string) => ({
  type: 'SET_PORTFOLIO_SEARCH_FILTER',
  searchTerm,
})

export const setPortfolioPageNumber = (pageNumber: number) => ({
  type: 'SET_PORTFOLIO_PAGE_NUMBER',
  pageNumber,
})

export const setPortfolioCompaniesSortOptions = (sortBy: CompaniesSortBy = companiesSortOptions.sortBy) => ({
  type: 'SET_PORTFOLIO_COMPANIES_SORT_OPTIONS',
  sortBy,
})

export const resetPortfolioCompaniesSortOptions = () => ({
  type: 'RESET_PORTFOLIO_COMPANIES_SORT_OPTIONS',
})

export const setPortfolioCompaniesByRiskTypePageNumber = (pageNumber: number) => ({
  type: 'SET_PORTFOLIO_COMPANIES_RISK_TYPE_PAGE_NUMBER',
  pageNumber,
})

export const setPortfolioCompaniesByRiskTypeSortOptions = (sortOptions: CompaniesSortOption = companiesSortOptions) => ({
  type: 'SET_PORTFOLIO_COMPANIES_RISK_TYPE_SORT_OPTIONS',
  sortOptions,
})

export const resetPortfolioCompaniesByRiskTypeSortOptions = () => ({
  type: 'SET_PORTFOLIO_COMPANIES_RISK_TYPE_SORT_OPTIONS',
  sortOptions: companiesSortOptions,
})

export const setEventsPageNumber = (pageNumber: number) => ({
  type: 'SET_EVENTS_PAGE_NUMBER',
  pageNumber,
})

export const setModalEventsPageNumber = (pageNumber: number) => ({
  type: 'SET_MODAL_EVENTS_PAGE_NUMBER',
  pageNumber,
})

export const resetModalEventsPage = () => ({
  type: 'SET_MODAL_EVENTS_PAGE_NUMBER',
  pageNumber: 0,
})

export const toggleRiskFilter = (riskRating: RiskRating = riskType) => ({
  type: 'TOGGLE_RISK_FILTER',
  riskRating,
})

export const setModalEventsSortOptions = (sortBy: EventsSortBy, sortDir: ?SortDir) => ({
  type: 'SET_MODAL_EVENTS_SORT_OPTIONS',
  sortBy,
  sortDir,
})

export const resetModalEventsSortOptions = () => ({
  type: 'RESET_MODAL_EVENTS_SORT_OPTIONS',
})

export const setChartType = (chartType: ChartType) => ({
  type: 'SET_CHART_TYPE',
  chartType,
})

export const setGraphDates = (graphDate: GraphDate) => ({
  type: 'SET_GRAPH_DATE',
  graphDate,
})

export const setExportsPageNumber = (pageNumber: number, type: string) => ({
  type: type === 'previous' ? 'SET_PREVIOUS_EXPORTS_PAGE_NUMBER' : 'SET_SCHEDULED_EXPORTS_PAGE_NUMBER',
  pageNumber,
})

export const setExportsSortOptions = (sortBy: ExportsSortBy, type: string) => ({
  type: type === 'previous' ? 'SET_PREVIOUS_EXPORTS_SORT_OPTIONS' : 'SET_SCHEDULED_EXPORTS_SORT_OPTIONS',
  sortBy,
})

export const resetExportsSortOptions = () => ({
  type: 'RESET_EXPORTS_SORT_OPTIONS',
})

export const resetConfirmMessage = () => ({
  type: 'RESET_CONFIRM_MESSAGE',
})



// WEBPACK FOOTER //
// ./src/store/ui/actions.js